import './Introduction.css';
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

export default function Introduction() {
    const slide1Ref = useRef(null);
    const slide2Ref = useRef(null);

    useGSAP(() => {
      const tl = gsap.timeline({ repeat: -1, defaults: { duration: 1 } });

      // Initialize slide opacities
      tl.set(slide1Ref.current, { opacity: 1 });
      tl.set(slide2Ref.current, { opacity: 0 });

      // Show first slide for 5s
      tl.to({}, { duration: 5 });

      // Crossfade to second slide
      tl.to(slide1Ref.current, { opacity: 0 }, "<");
      tl.to(slide2Ref.current, { opacity: 1 }, "<");

      // Show second slide for 5s
      tl.to({}, { duration: 5 });

      // Crossfade back to first slide
      tl.to(slide2Ref.current, { opacity: 0 });
      tl.to(slide1Ref.current, { opacity: 1 }, "<");

      // Then animate the welcome text (runs on every loop)
      tl.to(
        ".welcome-container",
        {
          y: 0,
          opacity: 1,
          stagger: 0.05,
          duration: 2.5,
          ease: "power4.out",
        },
        "-=1"
      );
    }, []);

    return (
      <section className="introduction-section">
        <div ref={slide1Ref} className="bg-slide" />
        <div ref={slide2Ref} className="bg-slide" />
        <div className="welcome-container">
          <p className="welcome-text">WELCOME TO</p>
          <h1 className="team-title">WOOD FC</h1>
        </div>
      </section>
    );
}